/** Versão do sistema — único ponto a atualizar a cada release (lida pelo ConfigService). */
export const APP_VERSION = '0.0.1';
